import { ClientContactForm } from '../components/FormModal/hooks/useClientFormModalContext';

export const trimClientContactNames = (clientContact: ClientContactForm) => {
  const { firstName, lastName } = clientContact;
  return {
    ...clientContact,
    firstName: (firstName ?? '').trim(),
    lastName: (lastName ?? '').trim(),
  };
};
